'use client'

import { useFeature } from '@growthbook/growthbook-react'

const PAYMENT_PRIORITY_FLAG = 'ab-payment-priority'

export type PaymentPriorityExperiment = {
  isVariant: boolean
  experimentId?: string
  variationId?: string
}

export function usePaymentPriorityAB(): PaymentPriorityExperiment {
  const feature = useFeature<string>(PAYMENT_PRIORITY_FLAG)

  return {
    isVariant: feature.value === 'variant',
    experimentId: feature.experiment?.key,
    variationId: feature.experimentResult?.key,
  }
}
